import { Button, Grid, Paper } from "@material-ui/core";
import MaterialTable, { MTableToolbar } from "material-table";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { exportUserMobileReport, getUserMobileReport } from "../../../api/reportApi";
import DateStartToEnd from "./components/DateStartToEnd";
import { getTableUserReportColumns, initialTableUserReportOptions } from "./reportOption";
import { exportExcel } from "../../../utils/xlsx";

function ReportUser() {
    // ref
    const controllerRef = useRef(null);
    const tableRef = useRef(null);

    // component state
    const [tableOptions, setTableOptions] = useState(initialTableUserReportOptions);
    const [datePick, setDatePick] = useState({
        startDate: "",
        endDate: "",
    });
    const [orderBy, setOrderBy] = useState({
        order: "",
        direction: "",
    });

    // fetch data
    const fetchData = useCallback(
        async query => {
            try {
                const queryParams = {
                    page: query?.page + 1 || 1,
                    limit: query?.pageSize || 10,
                    search: query?.search || "",
                    order: query?.orderBy?.field || "",
                    direction: query?.orderBy?.field ? query?.orderDirection : "",
                    startDate: datePick?.startDate ? moment(datePick?.startDate).format("YYYY-MM-DD") : "",
                    endDate: datePick?.endDate ? moment(datePick?.endDate).format("YYYY-MM-DD") : "",
                };
                setOrderBy({
                    order: query?.orderBy?.field || "",
                    direction: query?.orderBy?.field ? query?.orderDirection : "",
                });
                const res = await getUserMobileReport(queryParams, controllerRef.current?.signal);
                if (res) {
                    setTableOptions(currentState => ({
                        ...currentState,
                        currentPage: query?.page,
                        pageSize: query?.pageSize || 10,
                        totalData: res?.pagination?.totalData || 0,
                        order: query?.orderBy?.field || "usersMobileId",
                        direction: query?.orderBy?.field ? query?.orderDirection : "desc",
                    }));
                    return {
                        data: res?.data || [],
                        page: query?.page || 0,
                        totalCount: res?.pagination?.totalData || 0,
                    };
                }
                return {
                    data: [],
                    page: 0,
                    totalCount: 0,
                };
            } catch (error) {
                console.dir(error);
                return {
                    data: [],
                    page: 0,
                    totalCount: 0,
                };
            }
        },
        [datePick],
    );

    // search with start_date, end_date
    const handleSearchDate = useCallback(value => {
        setDatePick({
            startDate: value?.startDate || "",
            endDate: value?.endDate || "",
        });
        tableRef.current.onQueryChange();
    }, []);

    // clear search
    const handleClearSearch = useCallback(() => {
        setDatePick({
            startDate: "",
            endDate: "",
        });
        tableRef.current.onQueryChange();
    }, []);

    // export excel
    const handleExportExcel = useCallback(async () => {
        const res = await exportUserMobileReport({
            startDate: datePick?.startDate ? moment(datePick?.startDate).format("YYYY-MM-DD") : "",
            endDate: datePick?.endDate ? moment(datePick?.endDate).format("YYYY-MM-DD") : "",
            order: orderBy.order || "",
            direction: orderBy.direction || "",
        });
        const mappingData = res?.data?.map(item => ({
            HN: item?.hnNumber,
            Name: item?.fullname,
            Age: moment().diff(moment(item?.dob), "year"),
            Phone: item?.phoneNumber,
            "Application Date": moment(item?.createdAt).format("DD/MM/YYYY HH:mm"),
            Right: item?.patientPlan,
        }));
        const headers = ["HN", "Name", "Age", "Phone", "Application Date", "Right"];
        exportExcel(mappingData, headers, "user-report");
    }, [datePick, orderBy]);

    // run only first render
    useEffect(() => {
        controllerRef.current = new AbortController();
        // to avoid memory leaked.
        return () => {
            controllerRef.current.abort();
        };
    }, []);

    return (
        <div>
            <Grid container spacing={3}>
                <Grid item xs={12} className="mb-3">
                    <h1 className="t-text-primary">Report User</h1>
                </Grid>
                <Grid item xs={12}>
                    <Paper elevation={2} className="px-5">
                        <DateStartToEnd
                            onSearch={data => {
                                handleSearchDate(data);
                            }}
                            onClear={handleClearSearch}
                        />
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Paper>
                        {/* Table show data */}
                        <div className="t-table-custom">
                            <MaterialTable
                                tableRef={tableRef}
                                data={fetchData}
                                title=""
                                columns={getTableUserReportColumns}
                                options={tableOptions}
                                localization={{
                                    body: {
                                        emptyDataSourceMessage: "ไม่พบข้อมูลที่คุณต้องการ",
                                    },
                                }}
                                components={{
                                    Toolbar: props => (
                                        <div className="d-flex justify-content-end align-items-center px-2">
                                            <MTableToolbar {...props} />
                                            <Button className="btn t-btn-primary h-50" onClick={handleExportExcel}>
                                                Export as Excel
                                            </Button>
                                        </div>
                                    ),
                                }}
                            />
                        </div>
                    </Paper>
                </Grid>
            </Grid>
        </div>
    );
}

export default ReportUser;
